import { PropTypes } from "prop-types";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { getUnitMeetings } from "../../../api/meeting/meeting";
import { useQuery } from "react-query";
import moment from "moment";
import { QueryLoader } from "../../Loader";
import { MeetingsList } from "../../MeetingsList";

export default function UnitMeetings({ id }) {
	const { axiosPrivate } = useAxiosPrivate();
	const currentDate = new Date();

	const { isLoading: isFutureMeetingsLoading, data: futureMeetingsData } = useQuery(["futureUnitMeetings", id], () =>
		getUnitMeetings(
			axiosPrivate,
			id,
			moment().format("YYYY-MM-DD"),
			moment()
				.year(currentDate.getFullYear() + 2)
				.format("YYYY-MM-DD")
		)
	);

	const { isLoading: isOngoingMeetingsLoading, data: ongoingMeetingsData } = useQuery(["ongoingUnitMeetings", id], () =>
		getUnitMeetings(axiosPrivate, id, moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"))
	);

	const { isLoading: isArchiveMeetingsLoading, data: archiveMeetingsData } = useQuery(["archiveUnitMeetings", id], () =>
		getUnitMeetings(
			axiosPrivate,
			id,
			moment()
				.year(currentDate.getFullYear() - 3)
				.format("YYYY-MM-DD"),
			moment().format("YYYY-MM-DD")
		)
	);

	return (
		<>
			<h3>Future meetings</h3>
			{isFutureMeetingsLoading ? <QueryLoader /> : <MeetingsList data={futureMeetingsData} />}
			<h3>Ongoing meetings</h3>
			{isOngoingMeetingsLoading ? <QueryLoader /> : <MeetingsList data={ongoingMeetingsData} />}
			<h3>Archived meetings</h3>
			{isArchiveMeetingsLoading ? <QueryLoader /> : <MeetingsList data={archiveMeetingsData} />}
		</>
	);
}

UnitMeetings.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
